const opentokVideoIsAvailable = async (url) => {
  const response = await fetch(url, {
    method: 'get',
    headers: { Range: 'bytes=0-0' },
  })

  // any 2xx status
  if (response.ok === true) {
    return true
  }

  if (response.status === 404) {
    return false
  }

  throw new Error(`Could not check url ${url} Response status: ${response.status}`)
}

export default opentokVideoIsAvailable
